import React from 'react';
import { Calendar, Flag } from 'lucide-react';
import TaskStatusBadge from './TaskStatusBadge';

function TaskCard({ task, onClick }) {
  const { taskDetails, status, priority, createdAt, projectName, assignee, description } = task;
console.log(task)
  return (
    <div
      onClick={onClick}
      className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow cursor-pointer"
    >
      <div className="flex justify-between items-start mb-2">
        <h3 className="font-medium text-gray-900">{taskDetails}</h3>
        <TaskStatusBadge status={status.toLowerCase()} />
      </div>

      {description && (
        <p className="text-sm text-gray-700 mb-2">{description}</p>
      )}

      <p className="text-sm text-gray-600 mb-4">
        Assigned by: {assignee} | Project: {projectName}
      </p>

      <div className="flex items-center justify-between text-sm text-gray-500">
        <div className="flex items-center">
          <Calendar className="h-4 w-4 mr-1" />
          <span>{createdAt}</span>
        </div>
        <div className="flex items-center">
          <Flag
            className={`h-4 w-4 ${
              priority === 'high'
                ? 'text-red-500'
                : priority === 'medium'
                ? 'text-yellow-500'
                : 'text-blue-500'
            }`}
          />
        </div>
      </div>
    </div>
  );
}

export default TaskCard;
